import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  app_connection: true,
  cart: {},
  cartLastUpdate: "",
  isLoading: false,
  loginModalVisible: false,
  loginModalType: "login", // login or forgot-password
  menuDetailModalVisible: false,
  selectedFood: "",
  displayType: "",
  selectOrderTypeModalVisible: false,
  selectedOrderType: null,
  currentOrderType: null,
  mallSearch: "",
  modalTopUpVisible: false,
  hideShopAlertVisible: false,
  hideShopAlertDoNotShow: false,
  deliveryOperationHourAlertVisible: false,
  // FirstLoad
  isFirstLoad: true,
  visibleAlertSetWalletPin: false,
  amount: "",
  // locationModalVisible: false,
  // storeLocation: {
  //   data: {},
  //   success:false
  // },
  // locationList:[]
  hotline_no: "",
  whatsapp_no: "",
};

export default function appReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.RESET_APP_STATE:
      return { ...INITIAL_STATE };

    case actionTypes.NO_INTERNET:
      return {
        ...state,
        app_connection: false,
      };

    case actionTypes.ENABLE_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case actionTypes.DISABLE_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    // Login
    case actionTypes.SHOW_LOGIN_MODAL:
      return {
        ...state,
        loginModalVisible: true,
        loginModalType:
          action.data !== "forgot-password" ? "login" : "action.data",
      };

    case actionTypes.HIDE_LOGIN_MODAL:
      return {
        ...state,
        loginModalVisible: false,
      };

    case actionTypes.SWITCH_LOGIN_FORGOT_PASSWORD:
      return {
        ...state,
        loginModalType: action.data,
      };

    // Menu Detail Modal
    case actionTypes.SHOW_MENU_DETAIL_MODAL:
      return {
        ...state,
        menuDetailModalVisible: true,
        selectedFood: String(action.id),
        displayType: action.displayType,
      };

    case actionTypes.HIDE_MENU_DETAIL_MODAL:
      return {
        ...state,
        menuDetailModalVisible: false,
        selectedFood: INITIAL_STATE.selectedFood,
      };

    // Select Order Type Modal
    case actionTypes.SHOW_SELECT_ORDER_TYPE_MODAL:
      return {
        ...state,
        selectOrderTypeModalVisible: true,
        currentOrderType: action.data,
      };

    case actionTypes.HIDE_SELECT_ORDER_TYPE_MODAL:
      return {
        ...state,
        selectOrderTypeModalVisible: false,
        currentOrderType: null,
      };

    case actionTypes.CONSUMER_LOGIN_SUCCESS:
      return {
        ...state,
        loginModalVisible: false,
      };

    // Top Up Modal
    case actionTypes.SHOW_TOP_UP_MODAL:
      return {
        ...state,
        amount: action.data ? action.data : "",
        modalTopUpVisible: true,
      };

    case actionTypes.HIDE_TOP_UP_MODAL:
      return {
        ...state,
        modalTopUpVisible: false,
        amount: "",
      };

    case actionTypes.CLEAR_TOP_UP_AMOUNT:
      return {
        ...state,
        amount: "",
      };

    case actionTypes.LOAD_WALLET_TOP_UP_SUCCESS:
      return {
        ...state,
        modalTopUpVisible: false,
        amount: "",
      };

    // Order Type
    case actionTypes.GET_ORDER_TYPE:
      return {
        ...state,
      };
    case actionTypes.UPDATE_ORDER_TYPE:
      return {
        ...state,
        selectedOrderType: action.data,
      };
    case actionTypes.CLEAR_ORDER_TYPE:
      return {
        ...state,
        selectedOrderType: "",
      };

    // LOLOL Mall
    case actionTypes.UPDATE_MALL_SEARCH:
      return {
        ...state,
        mallSearch: action.data,
      };

    case actionTypes.CLEAR_MALL_SEARCH:
      return {
        ...state,
        mallSearch: INITIAL_STATE.mallSearch,
      };

    // Cart
    case actionTypes.GET_CART:
      return { ...state };
    case actionTypes.UPDATE_CART: {
      let newCart = cloneDeep(action.data);
      return {
        ...state,
        cart: newCart,
        cartLastUpdate: new Date(),
      };
    }
    case actionTypes.CLEAR_CART:
      return {
        ...state,
        cart: INITIAL_STATE.cart,
      };
    case actionTypes.SHOW_ALERT_SET_WALLET_PIN:
      return {
        ...state,
        visibleAlertSetWalletPin: true,
        isFirstLoad: false,
      };
    case actionTypes.HIDE_ALERT_SET_WALLET_PIN:
      return {
        ...state,
        visibleAlertSetWalletPin: false,
      };
    case actionTypes.UPDATE_ISFIRSTLOAD:
      return {
        ...state,
        isFirstLoad: false,
      };
    // Hide Shop
    case actionTypes.SHOW_HIDE_SHOP_ALERT: {
      return {
        ...state,
        hideShopAlertVisible: !state.hideShopAlertDoNotShow ? true : false,
      };
    }
    case actionTypes.HIDE_HIDE_SHOP_ALERT: {
      return {
        ...state,
        hideShopAlertVisible: false,
      };
    }
    case actionTypes.DO_NOT_SHOW_ALERT_HIDE_SHOP: {
      return {
        ...state,
        hideShopAlertDoNotShow: true,
      };
    }
    // Delivery Operation Hour
    case actionTypes.SHOW_DELIVERY_OPERATION_HOUR_ALERT: {
      return {
        ...state,
        deliveryOperationHourAlertVisible: true,
      };
    }
    case actionTypes.HIDE_DELIVERY_OPERATION_HOUR_ALERT: {
      return {
        ...state,
        deliveryOperationHourAlertVisible: false,
      };
    }
    case actionTypes.GET_PHONE_NO: {
      return {
        ...state,
      };
    }
    case actionTypes.GET_PHONE_NO_SUCCESS: {
      return {
        ...state,
        hotline_no: action.data.hotline_no,
        whatsapp_no: action.data.whatsapp_no,
      };
    }
    // Location
    // case actionTypes.SHOW_MODAL_LOCATION:
    //   return {
    //     ...state,
    //     // isFirstLoad: false,
    //     locationModalVisible: true,
    //   };
    // case actionTypes.HIDE_MODAL_LOCATION:
    //   return {
    //     ...state,
    //     locationModalVisible: false
    //   };
    // case actionTypes.GET_LOCATION:
    //   return {
    //     ...state,
    //     isLoading: true
    //   };
    // case actionTypes.GET_LOCATION_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     locationList: action.data.data
    //   };
    // case actionTypes.STORE_LOCATION:
    //   return {
    //     ...state,
    //     storeLocation: {
    //       data: action.data,
    //       success: false
    //     }
    //   };
    // case actionTypes.STORE_LOCATION_SUCCESS:
    //   return {
    //     ...state,
    //     locationModalVisible: false,
    //     isFirstLoad: false,
    //     storeLocation: {
    //       data: action.data,
    //       success: true
    //     }
    //   };

    default:
      return state;
  }
}
